import { saveAs } from 'file-saver';
import React from 'react';
import * as XLSX from 'xlsx';
import { constants } from '../../constants';
import useWebContext from '../../hooks/useWebContext';
import { MyMButton } from '../../ui-elements/MyMButton';
import { utility } from '../../utility';

/** MyMine Version2.0 SurveyResult画面追加
 * SurveyResultDownlodResultButton Component
 */
export const SurveyResultDownlodResultButton = ({ screenId, surveyId, surveySummaryInfo }) => {

  const { controlSettings } = useWebContext(screenId);

  /** ダウンロードクリック時処理*/
  const handleDownload = async (e, format) => {

    // workbookを作成
    const wb = XLSX.utils.book_new();
    // シートを作成
    const ws = XLSX.utils.aoa_to_sheet([]);

    // ヘッダ書き込み
    XLSX.utils.sheet_add_aoa(ws,
      [[
        controlSettings.LabelList.lblXlSurveyResutlHeader,
        null,
        `${utility.formatDate(surveySummaryInfo.StartDate)} ～ ${utility.formatDate(surveySummaryInfo.EndDate)}`
      ]],
      { origin: "A1" });

    const createWriteRowData = (answerData) => {
      const companyInfo = surveySummaryInfo.CompanyHierarchyList.find(c => answerData?.CompanyId === c.Id)
      const quesiontInfo = surveySummaryInfo.QuestionList.find(q => answerData?.QuestionId === q.QuestionId)
      // 2025.7.7 MyMine Version3.0対応 Add Start
      const questionOptionList = surveySummaryInfo.QuestionOptionList[quesiontInfo.QuestionId.toString()];
      // 2025.7.7 MyMine Version3.0対応 Add End
      const regionInfo = surveySummaryInfo.CompanyHierarchyList.find(rc =>
        answerData?.ParentCompanyId === null
          ? rc.Id === answerData.CompanyId
          : rc.Id === answerData?.ParentCompanyId
      );
      return {
        [controlSettings.LabelList.lblXlListQuestionNo]: quesiontInfo?.OrderNo,
        [controlSettings.LabelList.lblXlListQuestionType]:
          (() => {
            switch (quesiontInfo?.AnswerType) {
              case constants.SurveyAnswerType.Option:
                // 2025.7.7 MyMine Version3.0対応 Modify Start
                return controlSettings.LabelList.lblXlListQuestionTypeScaleValue;
                // 2025.7.7 MyMine Version3.0対応 Modify End
              case constants.SurveyAnswerType.Text:
                return controlSettings.LabelList.lblXlListQuestionTypeTextValue;
              // 2025.7.7 MyMine Version3.0対応 Add Start
              case constants.SurveyAnswerType.Checkbox:
                return controlSettings.LabelList.lblXlListQuestionTypeMultiSelectValue;
              case constants.SurveyAnswerType.Radiobutton:
                return controlSettings.LabelList.lblXlListQuestionTypeSingleSelectValue;
              // 2025.7.7 MyMine Version3.0対応 Add End
              default:
                return null;
            }
          })(),
        // 2025.7.7 MyMine Version3.0対応 Add Start
        [controlSettings.LabelList.lblXlListRequired]: quesiontInfo?.RequiredFlg ? controlSettings.LabelList.lblXlListValueNo : controlSettings.LabelList.lblXlListValueYes,
        // 2025.7.7 MyMine Version3.0対応 Add End
        [controlSettings.LabelList.lblXlListQuestionText]: quesiontInfo?.QuestionText,
        [controlSettings.LabelList.lblXlListRegion]: regionInfo?.Name,
        [controlSettings.LabelList.lblXlListCompany]: companyInfo?.Name,
        [controlSettings.LabelList.lblXlListName]: answerData?.UserName,
        [controlSettings.LabelList.lblXlListUserId]: answerData?.UserId,
        [controlSettings.LabelList.lblXlListRole]: answerData?.RoleName,
        [controlSettings.LabelList.lblXlListAnswer]:
          (() => {
            switch (quesiontInfo?.AnswerType) {
              case constants.SurveyAnswerType.Option:
                return answerData.AnswerOption;
              case constants.SurveyAnswerType.Text:
                return answerData.AnswerText;
              // 2025.7.7 MyMine Version3.0対応 Add Start
              case constants.SurveyAnswerType.Checkbox:
              case constants.SurveyAnswerType.Radiobutton:
                return answerData.AnswerSelectOptionList?.map(x => questionOptionList.find(o => x === o.OptionId)?.OptionText).join(',')
              // 2025.7.7 MyMine Version3.0対応 Add End
              default:
                return null;
            }
          })(),
        // 2025.7.7 MyMine Version3.0対応 Add Start
        [controlSettings.LabelList.lblXlListOthers]: answerData?.AnswerSelectOptionOther,
        // 2025.7.7 MyMine Version3.0対応 Add End
      };
    }

    // シートデータを作成
    const writeResultDataList =
      surveySummaryInfo.AnswerResultList.length === 0
        ? [createWriteRowData(null)]
        : surveySummaryInfo.AnswerResultList.map(createWriteRowData);
    // 書き込み
    XLSX.utils.sheet_add_json(ws, writeResultDataList, { origin: 'B2' });

    // 列幅設定
    ws['!cols'] = [
      { wch: 3 },
      { wch: 11 },
      { wch: 13 },
      // 2025.7.7 MyMine Version3.0対応 Add Start
      { wch: 8 },
      // 2025.7.7 MyMine Version3.0対応 Add End
      { wch: 60 },
      { wch: 12 },
      { wch: 12 },
      { wch: 17 },
      { wch: 25 },
      { wch: 12 },
      { wch: 40 },
      // 2025.7.7 MyMine Version3.0対応 Add Start
      { wch: 40 },
      // 2025.7.7 MyMine Version3.0対応 Add End
    ];

    // Workbookにシートを追加
    XLSX.utils.book_append_sheet(wb, ws, controlSettings.LabelList.lblXlSurveyResultSheetName);

    // Workbookをバイナリ書き出し
    const wbout = XLSX.write(wb, {
      bookType: 'xlsx',
      type: 'array',
    });

    // ダウンロードをトリガー
    saveAs(new Blob([wbout], { type: 'application/octet-stream' }), `SurveyResult_${surveyId}_${utility.formatDateTime(new Date(), 'yyyyMMddHHmmss')}.xlsx`)
  }

  return (
    <MyMButton onClick={handleDownload}>{controlSettings.LabelList.btnDownloadSurveyResult}</MyMButton>
  );
}